import { type UserAction, userActions, type UserState } from '../context';
import { patchChangesNothing } from './sameValue';

export const userReducer = (state: UserState, action: UserAction) => {
  let updatedState = state;
  switch (action.type) {
    case userActions.SET_IS_AUTHENTICATED:
      if (state.user.isAuthenticated === action.payload) return state;
      updatedState = {
        ...state,
        user: { ...state.user, isAuthenticated: action.payload }
      };
      break;
    case userActions.SET_USER: {
      // isAuthenticated is not taken from the payload: SET_IS_AUTHENTICATED
      // owns it.
      const fields = {
        id: action.payload.id,
        name: action.payload.name,
        username: action.payload.username,
        isPrivate: action.payload.isPrivate,
        email: action.payload.email,
        emailVerificationStatus: action.payload.emailVerificationStatus,
        bio: action.payload.bio,
        avatarKey: action.payload.avatarKey,
        robohash: action.payload.robohash,
        bannerKey: action.payload.bannerKey,
        twoFaEnabled: action.payload.twoFaEnabled,
        tronsBalance: action.payload.tronsBalance,
        onboardingPath: action.payload.onboardingPath,
        oauthProviders: action.payload.oauthProviders,
        oauthProvider: action.payload.oauthProvider,
        hasPassword: action.payload.hasPassword,
        hasPasskey: action.payload.hasPasskey,
        tag: action.payload.tag,
        verificationRequestedAt: action.payload.verificationRequestedAt,
        deletionScheduledAt: action.payload.deletionScheduledAt,
        isIncognito: action.payload.isIncognito
      };
      // The same user again (a cookie refresh, a refetch) rerenders nothing.
      if (patchChangesNothing(state.user, fields)) return state;
      updatedState = {
        ...state,
        user: { ...state.user, ...fields }
      };
      break;
    }
    case userActions.ADD_TRONS:
      if (action.payload === 0) return state;
      updatedState = {
        ...state,
        user: {
          ...state.user,
          tronsBalance: state.user.tronsBalance + action.payload
        }
      };
      break;
    case userActions.REMOVE_TRONS:
      if (action.payload === 0) return state;
      updatedState = {
        ...state,
        user: {
          ...state.user,
          tronsBalance: state.user.tronsBalance - action.payload
        }
      };
      break;
    default:
      return state;
  }
  return updatedState;
};
